import { Wallet, WalletPageConnection } from "@auer-steel/Services/AuerSteelApiModels";
import isApiError from "@insite/client-framework/Common/isApiError";
import { del, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const apiUrl = "/api/auersteel/v1/invoices";

export interface PaymentInformation {
    AccountNumber: string;
    RoutingNumber: string;
    BankAccountType: string;
    BankName: string;
}

export interface AchApiResult {
    success: boolean;
    responseMessage: string;
}

export async function getWalletPageConnection(): Promise<ServiceResult<WalletPageConnection>> {
    const getHostedParametersApiUrl = `${apiUrl}/create/getHostedPageParameters`;
    const walletPageConnectionResult = await fetch(getHostedParametersApiUrl, { cache: "no-store" })
        .then(res => res.json())
        .then(data => data);

    return {
        successful: true,
        result: walletPageConnectionResult as WalletPageConnection,
    };
}

export async function getWalletsList(): Promise<ServiceResult<Wallet[]>> {
    const getWalletsListApiUrl = `${apiUrl}/GetAvailablePayments`;
    const walletsListResult = await get<any>(getWalletsListApiUrl);
    return {
        successful: true,
        result: walletsListResult["Wallets"] as Wallet[],
    };
}

export async function updateAchAccount(parameter: PaymentInformation, paymentMethodId: string): Promise<ServiceResult<Wallet>> {
    try {
        const updateAchAccountApiUrl = `${apiUrl}/UpdateAchAccount/${paymentMethodId}`;
        const paymentInfo = {
            AccountNumber: parameter.AccountNumber,
            RoutingNumber: parameter.RoutingNumber,
            BankAccountType: parameter.BankAccountType,
            BankName: parameter.BankName
        };
        const updateAchAccountResult = await post<any, any>(updateAchAccountApiUrl, paymentInfo);
        return {
            successful: true,
            result: updateAchAccountResult["Wallet"] as Wallet,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorJson.message,
        };
    }
}

export async function createAchAccount(parameter: PaymentInformation): Promise<ServiceResult<AchApiResult>> {
    const createAchAccountApiUrl = `${apiUrl}/AddNewPaymentMethod`;
    const paymentInfo = {
        AccountNumber: parameter.AccountNumber,
            RoutingNumber: parameter.RoutingNumber,
            BankAccountType: parameter.BankAccountType,
            BankName: parameter.BankName
    };
    const createAchAccountResult = await post<any, AchApiResult>(createAchAccountApiUrl, paymentInfo);
    return {  
        successful: true,      
        result: createAchAccountResult
    };
}

export async function getWalletById(paymentProfileId: string): Promise<ServiceResult<Wallet>> {
    const getWalletByIdApiUrl = `${apiUrl}/get${paymentProfileId}`;
    const walletResult = await get<any>(getWalletByIdApiUrl);

    return {
        successful: true,
        result: walletResult as Wallet,
    };
}

export async function deleteWalletById(cardId: string) {
    await del(`${apiUrl}/DeleteAccountById/${cardId}`, (status => status === 200));
}
